import Vue from 'vue';

const defaultState = () => {
  return {
    userCertifications: {},
  };
};

const state = defaultState();

const getters = {
  userCertifications: state => state.userCertifications,
  userCertificationsList: (state, getters, rootState, rootGetters) => {
    let ucs = Object.keys(state.userCertifications).map(id => state.userCertifications[id]);
    // filter out certs that don't have a present category (happens for content review certs)
    ucs = ucs.filter(uc => {
      const categoryId = rootGetters['certifications/certifications'][uc.certificationId].categoryId;
      return rootGetters['categories/categories'][categoryId];
    });
    return ucs.sort((a, b) => rootGetters['certifications/certifications'][a.certificationId].order - rootGetters['certifications/certifications'][b.certificationId].order);
  },
};

const mutations = {
  setUserCertifications(state, userCertifications) {
    for (let userCertification of userCertifications) {
      Vue.set(state.userCertifications, userCertification.id, userCertification);
    }
  },
  reset(state) {
    Object.assign(state, defaultState());
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
